// Meoks: ürün adı altına yıldız + yorum sayısı inject
(function () {
  var I18N = window.MeoksI18n || {};
  function t(path, vars) {
    var parts = path.split('.');
    var obj = I18N;
    for (var i = 0; i < parts.length; i++) { obj = obj && obj[parts[i]]; }
    var str = obj || path;
    if (vars) {
      for (var k in vars) { str = str.split('__' + k + '__').join(vars[k]); }
    }
    return str;
  }
  function inject() {
    // Zaten dolu bir row varsa cik. Sadece Kaydet'li yarim row varsa kaldir, dolu olani sonra ekleyecegiz.
    var existingRow = document.querySelector('.meoks-rating-row[data-injected]');
    if (existingRow) {
      if (existingRow.querySelector('.meoks-rating-summary')) return;
      existingRow.remove();
    }
    var reviewsHead = document.querySelector('[data-meoks-reviews-toggle]');
    // reviewsHead yoksa yine de favori + save renderlanabilsin
    var avg = 0, count = 0;
    if (reviewsHead) {
      var avgEl = reviewsHead.querySelector('.meoks-reviews__avg-num');
      var countEl = reviewsHead.querySelector('.meoks-reviews__count');
      if (avgEl) avg = parseFloat(avgEl.textContent) || 0;
      if (countEl) {
        var ct = countEl.textContent;
        var ctm = ct.match(/(\d+)/);
        count = ctm ? parseInt(ctm[1], 10) : 0;
      }
    }

    // Sadece ana ürün detayındaki başlığı bul (product-card / recommendations exclude)
    var titleEl = null;
    var candidates = document.querySelectorAll('.product-details h1, [data-testid="product-information-details"] h1');
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c.closest('.product-card, .card-gallery, [data-product-card], [class*="product-recommendation"], [data-testid*="card"]')) continue;
      titleEl = c;
      break;
    }
    if (!titleEl) return;
    // İçeren parent zaten ratinge sahipse durumu kontrol et
    var existing = titleEl.parentElement.querySelector(':scope > .meoks-rating-summary');
    if (existing) return;

    var fillPct = (avg / 5 * 100).toFixed(1) + '%';
    var ratingHtml = '<div class="meoks-rating-row">'
      + '<a href="#meoks-reviews" class="meoks-rating-summary">'
      + '<span class="meoks-stars" aria-label="' + t('rating.starsLabel', {R: avg}) + '" style="--meoks-fill:' + fillPct + '">'
      + '<span class="meoks-stars__base">★★★★★</span>'
      + '<span class="meoks-stars__fill">★★★★★</span>'
      + '</span>'
      + '<span class="meoks-rating-summary__num">' + avg + '</span>'
      + '<span class="meoks-rating-summary__count">' + t('rating.reviewsCount', {C: count}) + '</span></a>';

    // Favori sayisi — row icinde, yildizdan hemen sonra (Soru Sor'un solunda)
    var metaForFav = document.getElementById('meoks-product-meta');
    if (metaForFav) {
      try {
        var mf = JSON.parse(metaForFav.textContent);
        var bFavInline = parseInt(mf.favori, 10) || 0;
        if (bFavInline >= 50) {
          var fInline = bFavInline >= 1000
            ? (Math.round(bFavInline / 100) / 10).toString().replace('.', ',') + 'B'
            : bFavInline.toString();
          ratingHtml += '<span class="meoks-fav-inline" style="display:inline-flex;align-items:center;gap:4px;font-size:11px;color:#555;line-height:1;">'
            + '<svg viewBox="0 0 24 24" style="width:12px;height:12px;flex:0 0 12px;" fill="#e11d48" stroke="#e11d48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
            + '<strong style="font-weight:600;color:#111;">' + fInline + '</strong> ' + t('rating.favoriteShort') + '</span>';
        }
      } catch (e) {}
    }

    // QA count — Favori'nin sagina
    var qaToggle = document.querySelector('[data-meoks-qa-toggle]');
    var qaCount = 0;
    if (qaToggle) {
      var qaCountEl = qaToggle.querySelector('.meoks-reviews__count');
      if (qaCountEl) {
        var qaMatch = qaCountEl.textContent.match(/(\d+)/);
        qaCount = qaMatch ? parseInt(qaMatch[1], 10) : 0;
      }
    }
    var qaLabel = qaCount > 0 ? t('qa.qaCount', {C: qaCount}) : t('qa.askQuestion');
    ratingHtml += '<a href="#meoks-qa" class="meoks-qa-summary">'
      + '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>'
      + '<span>' + qaLabel + '</span></a>';
    // Favori sayısı
    var metaEl = document.getElementById('meoks-product-meta');
    if (metaEl) {
      try {
        var meta = JSON.parse(metaEl.textContent);
        var baseFav = parseInt(meta.favori, 10) || 0;
        var key = 'meoks_fav_' + meta.handle;
        var isFav = localStorage.getItem(key) === '1';
        var displayFav = baseFav + (isFav ? 1 : 0);
        ratingHtml += '';
      } catch (e) {}
    }
    ratingHtml += '</div>';

    var wrap = document.createElement('span');
    wrap.innerHTML = ratingHtml;
    var rowEl = wrap.firstChild;
    // Rating click → reviews scroll + expand
    var ratingLink = rowEl.querySelector('.meoks-rating-summary');
    if (ratingLink) ratingLink.addEventListener('click', function (e) {
      e.preventDefault();
      var t = document.querySelector('[data-meoks-reviews-toggle]');
      if (t && !t.classList.contains('is-open')) t.click();
      var target = document.getElementById('meoks-reviews');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // QA click → qa scroll + expand
    var qaLink = rowEl.querySelector('.meoks-qa-summary');
    if (qaLink) qaLink.addEventListener('click', function (e) {
      e.preventDefault();
      var t = document.querySelector('[data-meoks-qa-toggle]');
      if (t && !t.classList.contains('is-open')) t.click();
      var target = document.getElementById('meoks-qa');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // Kaydet (bookmark) butonu — QA linkinin yanına
    var metaForSave = document.getElementById('meoks-product-meta');
    if (metaForSave) {
      try {
        var ms = JSON.parse(metaForSave.textContent);
        var savedKey = 'meoks_saved_lists';
        var raw = localStorage.getItem(savedKey);
        var lists = raw ? JSON.parse(raw) : {};
        var isInAny = Object.keys(lists).some(function (k) { return (lists[k] || []).indexOf(ms.handle) !== -1; });
        ratingHtml += '<button type="button" class="meoks-save-btn' + (isInAny ? ' is-saved' : '') + '" data-meoks-save data-handle="' + ms.handle + '" aria-label="' + t('save.save') + '">'
          + '<svg viewBox="0 0 24 24" width="14" height="14" fill="' + (isInAny ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>'
          + '<span>' + t('save.save') + '</span></button>';
      } catch (e) {}
    }
    // (Favori artik row icinde inline — ayri satir kaldirildi)
    // Favori toggle
    var favBtn = rowEl.querySelector('[data-meoks-fav]');
    if (favBtn) favBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var h = favBtn.getAttribute('data-handle');
      var base = parseInt(favBtn.getAttribute('data-base'), 10) || 0;
      var key = 'meoks_fav_' + h;
      var now = localStorage.getItem(key) === '1';
      if (now) { localStorage.removeItem(key); }
      else { localStorage.setItem(key, '1'); }
      var nowFav = !now;
      favBtn.classList.toggle('is-fav', nowFav);
      var svg = favBtn.querySelector('svg');
      if (svg) svg.setAttribute('fill', nowFav ? 'currentColor' : 'none');
      var c = favBtn.querySelector('.meoks-fav-summary__count');
      if (c) c.textContent = base + (nowFav ? 1 : 0);
    });
    // Kaydet butonu — modal aç
    var saveBtn = rowEl.querySelector('[data-meoks-save]');
    if (saveBtn) saveBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      openSaveModal(saveBtn.getAttribute('data-handle'), saveBtn);
    });
    rowEl.setAttribute('data-injected', '1');
    titleEl.insertAdjacentElement('afterend', rowEl);

    // Stok uyarısı — selected variant'ın stoğu ≤3 ise göster
    injectStock(titleEl);
  }

  // ===== Kaydet Modal (Instagram tarzı liste) =====
  var SAVED_KEY = 'meoks_saved_lists';
  function getLists() { try { return JSON.parse(localStorage.getItem(SAVED_KEY)) || {}; } catch (e) { return {}; } }
  function setLists(o) { localStorage.setItem(SAVED_KEY, JSON.stringify(o)); }
  function openSaveModal(handle, srcBtn) {
    var existing = document.getElementById('meoks-save-modal');
    if (existing) existing.remove();
    var lists = getLists();
    // selection state (kopya, modal kapanırken Kaydet ile yazılır)
    var selection = {};
    Object.keys(lists).forEach(function (k) { selection[k] = (lists[k] || []).indexOf(handle) !== -1; });

    var wrap = document.createElement('div');
    wrap.id = 'meoks-save-modal';
    wrap.className = 'meoks-save-modal';
    wrap.innerHTML = '<div class="meoks-save-modal__backdrop" data-close="1"></div>'
      + '<div class="meoks-save-modal__box">'
      + '<header><h3>' + t('save.save') + '</h3><button class="meoks-save-modal__close" data-close="1" aria-label="' + t('qa.close') + '">×</button></header>'
      + '<div class="meoks-save-modal__lists" data-lists></div>'
      + '<div class="meoks-save-modal__new-wrap" data-new-wrap></div>'
      + '<div class="meoks-save-modal__footer">'
      + '<button type="button" class="meoks-save-modal__newbtn" data-newbtn>' + t('save.newList') + '</button>'
      + '<button type="button" class="meoks-save-modal__savebtn" data-savebtn>' + t('save.save') + '</button>'
      + '</div></div>';
    document.body.appendChild(wrap);

    function renderLists() {
      var box = wrap.querySelector('[data-lists]');
      var keys = Object.keys(lists);
      if (keys.length === 0) {
        box.innerHTML = '<p class="meoks-save-modal__empty">' + t('save.savedListsEmpty') + '</p>';
        return;
      }
      box.innerHTML = keys.map(function (k) {
        var picked = !!selection[k];
        return '<button type="button" class="meoks-save-modal__list' + (picked ? ' is-in' : '') + '" data-list="' + encodeURIComponent(k) + '">'
          + '<span class="meoks-save-modal__list-icon">' + (picked ? '✓' : '+') + '</span>'
          + '<span class="meoks-save-modal__list-name">' + k + '</span>'
          + '<span class="meoks-save-modal__list-count">' + (lists[k] || []).length + '</span></button>';
      }).join('');
      box.querySelectorAll('[data-list]').forEach(function (el) {
        el.addEventListener('click', function () {
          var name = decodeURIComponent(el.getAttribute('data-list'));
          selection[name] = !selection[name];
          renderLists();
        });
      });
    }
    renderLists();

    wrap.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', function () { wrap.remove(); }); });

    wrap.querySelector('[data-newbtn]').addEventListener('click', function () {
      var nw = wrap.querySelector('[data-new-wrap]');
      if (nw.querySelector('input')) return;
      nw.innerHTML = '<div class="meoks-save-modal__new"><input type="text" placeholder="' + t('save.listNamePlaceholder') + '" maxlength="40"><button type="button">' + t('save.create') + '</button></div>';
      var inp = nw.querySelector('input'); inp.focus();
      function create() {
        var name = (inp.value || '').trim();
        if (!name) return;
        if (!lists[name]) lists[name] = [];
        selection[name] = true;
        nw.innerHTML = '';
        renderLists();
      }
      nw.querySelector('button').addEventListener('click', create);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); create(); } });
    });

    wrap.querySelector('[data-savebtn]').addEventListener('click', function () {
      var L = getLists();
      Object.keys(selection).forEach(function (name) {
        if (!L[name]) L[name] = [];
        var idx = L[name].indexOf(handle);
        if (selection[name] && idx === -1) L[name].push(handle);
        else if (!selection[name] && idx !== -1) L[name].splice(idx, 1);
      });
      // Lokalde yeni eklediğimiz boş listeler de kaydedilsin
      Object.keys(lists).forEach(function (name) { if (!L[name]) L[name] = lists[name]; });
      setLists(L);
      var nowAny = Object.keys(L).some(function (k) { return (L[k] || []).indexOf(handle) !== -1; });
      if (srcBtn) {
        srcBtn.classList.toggle('is-saved', nowAny);
        var svg = srcBtn.querySelector('svg'); if (svg) svg.setAttribute('fill', nowAny ? 'currentColor' : 'none');
      }
      wrap.remove();
    });
  }
  window.meoksOpenSaveModal = openSaveModal;

  // Standalone Kaydet butonu — review olmasa da render et
  function injectSaveStandalone() {
    if (document.querySelector('[data-meoks-save]')) return;
    var metaEl = document.getElementById('meoks-product-meta');
    if (!metaEl) return;
    var meta;
    try { meta = JSON.parse(metaEl.textContent); } catch (e) { return; }
    var titleEl = null;
    var candidates = document.querySelectorAll('.product-details h1, [data-testid="product-information-details"] h1');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].closest('.product-card, .card-gallery, [data-product-card], [class*="product-recommendation"]')) continue;
      titleEl = candidates[i]; break;
    }
    if (!titleEl) return;
    // Eğer rating row varsa içine ekle, yoksa yeni standalone row oluştur
    var rowEl = document.querySelector('.meoks-rating-row');
    if (!rowEl) {
      rowEl = document.createElement('div');
      rowEl.className = 'meoks-rating-row';
      rowEl.setAttribute('data-injected', '1');
      titleEl.insertAdjacentElement('afterend', rowEl);
    }
    if (rowEl.querySelector('[data-meoks-save]')) return;
    var L = getLists();
    var isInAny = Object.keys(L).some(function (k) { return (L[k] || []).indexOf(meta.handle) !== -1; });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'meoks-save-btn' + (isInAny ? ' is-saved' : '');
    btn.setAttribute('data-meoks-save', '1');
    btn.setAttribute('data-handle', meta.handle);
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="' + (isInAny ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg><span>' + t('save.save') + '</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      openSaveModal(meta.handle, btn);
    });
    rowEl.appendChild(btn);
  }
  setTimeout(injectSaveStandalone, 600);
  setTimeout(injectSaveStandalone, 1600);

  // Zoom dialog'da fare ile pan — parent container üzerinde mousemove dinle
  document.addEventListener('mousemove', function (e) {
    var dlg = document.querySelector('.dialog-zoomed-gallery__dialog[open]') || document.querySelector('.dialog-zoomed-gallery__dialog');
    if (!dlg) return;
    var imgs = dlg.querySelectorAll('.product-media img.is-meoks-zoomed');
    if (!imgs.length) return;
    imgs.forEach(function (img) {
      var parent = img.parentElement;
      var rect = parent.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) return;
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transition = 'transform-origin 0.05s linear';
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  });

  // Zoom dialog: tek tıklamada 2x zoom, tekrar tıklamada normale dön
  var _meoksZoomLock = 0;
  document.addEventListener('click', function (e) {
    var media = e.target.closest('.dialog-zoomed-gallery__dialog .product-media');
    if (!media) return;
    if (e.target.closest('.dialog-thumbnails-list, button, a')) return;
    var now = Date.now();
    if (now - _meoksZoomLock < 400) return; // debounce / Horizon kendi handler'ına engel
    _meoksZoomLock = now;
    e.preventDefault();
    e.stopPropagation();
    var img = media.querySelector('img');
    if (!img) return;
    var isZoomed = img.classList.contains('is-meoks-zoomed');
    if (isZoomed) {
      img.style.transition = 'transform 0.3s ease';
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = '50% 50%';
      img.classList.remove('is-meoks-zoomed');
    } else {
      var rect = img.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2)';
      img.classList.add('is-meoks-zoomed');
    }
  }, true);

  function getStockMap() {
    var el = document.getElementById('meoks-variant-stocks');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  function showStockWarn(stock) {
    var oldWarns = document.querySelectorAll('.meoks-stock-warn');
    for (var i = 0; i < oldWarns.length; i++) oldWarns[i].remove();
    if (!(stock > 0 && stock <= 3)) return;
    var titleEl = document.querySelector('.product-details h1, [data-testid="product-information-details"] h1');
    if (!titleEl) return;
    var stockEl = document.createElement('div');
    stockEl.className = 'meoks-stock-warn';
    stockEl.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v4M12 17h.01"/><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg> ' + t('stock.lowStock', {C: stock});
    var rowEl = document.querySelector('.meoks-rating-row');
    if (rowEl) rowEl.insertAdjacentElement('afterend', stockEl);
    else titleEl.insertAdjacentElement('afterend', stockEl);
  }
  function injectStock(titleEl) {
    var stocks = getStockMap();
    var vid = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    if (!vid) {
      // İlk available variant'ı bul
      var checked = document.querySelector('.product-details input[type="radio"]:checked');
      vid = checked ? checked.getAttribute('data-variant-id') : null;
    }
    if (!vid) {
      var firstAvail = Object.keys(stocks).find(function (k) { return stocks[k] > 0; });
      vid = firstAvail;
    }
    if (vid && stocks[vid] !== undefined) showStockWarn(stocks[vid]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
  // Variant değişimi gibi durumlar için retry
  setTimeout(inject, 500);
  setTimeout(inject, 1500);
  // Variant degisiminde stok uyarisini yeniden inject et
  document.addEventListener('change', function(e){
    var t=e.target;
    if(!t) return;
    if(t.matches && (t.matches('input[type="radio"][data-variant-id]') || t.matches('input[name^="Beden"]') || t.matches('variant-picker input, .variant-picker input'))){
      setTimeout(inject, 50);
      setTimeout(inject, 350);
    }
  }, true);

  // Bagimsiz FAVORI satiri — sadece inject() icinden inline render edilemediyse yedek
  function standaloneFavInject() {
    if (document.querySelector('.meoks-fav-inline')) return true;
    if (document.querySelector('.meoks-fav-line[data-standalone]')) return true;
    var metaEl = document.getElementById('meoks-product-meta');
    if (!metaEl) return false;
    var titleEl = findMainTitle ? findMainTitle() : (function(){
      var c = document.querySelectorAll('.product-details h1, [data-testid="product-information-details"] h1');
      for (var i = 0; i < c.length; i++) {
        if (c[i].closest('.product-card, .card-gallery, [data-product-card], [class*="product-recommendation"], [data-testid*="card"]')) continue;
        return c[i];
      }
      return null;
    })();
    if (!titleEl) return false;
    try {
      var meta = JSON.parse(metaEl.textContent);
      var bFav = parseInt(meta.favori, 10) || 0;
      if (bFav < 50) return true;
      var fmt = bFav >= 1000
        ? (Math.round(bFav / 100) / 10).toString().replace('.', ',') + 'B'
        : bFav.toString();
      var fline = document.createElement('div');
      fline.className = 'meoks-fav-line';
      fline.setAttribute('data-standalone', '1');
      fline.style.cssText = 'display:flex;align-items:center;gap:6px;margin:6px 0 8px;font-size:12px;color:#555;';
      fline.innerHTML = '<svg viewBox="0 0 24 24" style="width:12px;height:12px;flex:0 0 12px;" fill="#e11d48" stroke="#e11d48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span>' + t('rating.favoritedBy', {C: fmt}) + '</span>';
      // rating-row varsa onun altina, yoksa basligin altina
      var rowEl = document.querySelector('.meoks-rating-row');
      if (rowEl) {
        if (!rowEl.nextElementSibling || !rowEl.nextElementSibling.classList.contains('meoks-fav-line')) {
          rowEl.insertAdjacentElement('afterend', fline);
        }
      } else {
        titleEl.insertAdjacentElement('afterend', fline);
      }
      return true;
    } catch (e) { return false; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', standaloneFavInject);
  else standaloneFavInject();
  [400, 1000, 2000].forEach(function (ms) { setTimeout(standaloneFavInject, ms); });

  // Bagimsiz stok uyarisi runner — yorum olmasa da calismali, ilk acilista ve tek-bedenli urunlerde dahi
  function findMainTitle() {
    var c = document.querySelectorAll('.product-details h1, [data-testid="product-information-details"] h1');
    for (var i = 0; i < c.length; i++) {
      if (c[i].closest('.product-card, .card-gallery, [data-product-card], [class*="product-recommendation"], [data-testid*="card"]')) continue;
      return c[i];
    }
    return null;
  }
  function standaloneStockInject() {
    var titleEl = findMainTitle();
    if (!titleEl) return false;
    var stocks = getStockMap();
    if (!Object.keys(stocks).length) return false;
    var vid = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    if (!vid) {
      var checked = document.querySelector('.product-details input[type="radio"]:checked, .product-details input[type="radio"][checked]');
      vid = checked ? (checked.getAttribute('data-variant-id') || checked.value) : null;
    }
    if (!vid) {
      var firstAvail = Object.keys(stocks).find(function (k) { return stocks[k] > 0; });
      vid = firstAvail;
    }
    if (vid && stocks[vid] !== undefined) showStockWarn(stocks[vid]);
    return true;
  }
  function tryStock() {
    if (standaloneStockInject()) return;
    // DOM henuz hazir degilse retry zinciri
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryStock);
  else tryStock();
  [300, 800, 1500, 2500].forEach(function (ms) { setTimeout(tryStock, ms); });
  function refreshStockForVariant(variantId) {
    var stocks = getStockMap();
    if (variantId && stocks[variantId] !== undefined) showStockWarn(stocks[variantId]);
  }
  ['variantUpdate', 'variant:update', 'on:variant:change'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var v = e.resource || (e.detail && (e.detail.resource || e.detail.variant));
      if (v && v.id) refreshStockForVariant(v.id);
    }, true);
  });
  // URL ?variant değişimini de yakala (popstate + History API patch)
  window.addEventListener('popstate', function () {
    var vid = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    if (vid) refreshStockForVariant(vid);
  });
  var _ps = history.pushState;
  history.pushState = function () { _ps.apply(this, arguments); setTimeout(function(){ var vid = (location.search.match(/[?&]variant=(\d+)/)||[])[1]; if (vid) refreshStockForVariant(vid); }, 50); };
})();
